import { Button } from "@/components/ui/button";
import { MessageSquare, ArrowRight } from "lucide-react";

interface FeedbackBannerProps {
  onFeedbackClick?: () => void;
}

const FeedbackBanner = ({ onFeedbackClick }: FeedbackBannerProps) => {
  return (
    <section className="mt-4">
      <div className="relative overflow-hidden rounded-2xl border border-accent/20 bg-gradient-to-br from-accent/10 via-background to-primary/5 px-6 py-6 text-center">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,hsl(var(--accent)/0.08),transparent_60%)]" />
        <div className="relative z-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-accent/20 bg-accent/5 text-xs text-accent-foreground mb-3">
            <MessageSquare className="w-3 h-3" />
            We'd love your input
          </div>
          <h3 className="font-bold text-lg mb-2">Help Us Improve</h3>
          <p className="text-sm text-muted-foreground max-w-sm mx-auto mb-5">
            Share your feedback, ideas, or anything you'd like to see improved. Your input shapes the product.
          </p>
          <Button onClick={onFeedbackClick} variant="outline">
            Share Feedback
            <ArrowRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </div>
    </section>
  );
};

export default FeedbackBanner;
